import React, { useEffect, useRef, useState } from 'react';

/**
 * HupalupaLokasyonReport: HUPALUPA'nın Türkiye'deki Google Haritalar kayıtları —
 * puan, yorum sayısı ve her kayıttan en yeni yorumların tam metni.
 * Route: /reports/hupalupa-lokasyon (ProtectedRoute allowBrandIds, sidebar'da VAR)
 *
 * Hupalupa platformda GERÇEK bir marka, o yüzden e-posta izni değil `allowBrandIds`
 * deseni — HupalupaGoReport'taki gibi iki Hupalupa markası da kabul ediliyor
 * (Eğlence + Hupalupa).
 *
 * İçerik statik — API çağrısı yok. Veri 12 Ağu 2026'da google-reviews-scraper
 * (RapidAPI) üzerinden 345 sorguluk Türkiye taramasıyla çekilip HTML'e gömüldü.
 * Yeniden üretmek için: node src/pages/hupalupa-lokasyon-report/build.js
 *
 * Rapor iframe içinde çalışır: kendi CSS'i `:root`, `body`, `h1`, `table` gibi
 * global seçiciler taşıyor; srcDoc izolasyonu dashboard'un stilini korur.
 *
 * HupalupaYoutubeReport'tan farkı: o sayfa tüm ekranı kaplıyor (route sidebar'ın
 * dışında). Bu sayfa sidebar'dan açılıyor, o yüzden iframe içerik alanına
 * oturuyor — yoksa kullanıcı sidebar'ı kaybedip geri dönemez.
 */
export default function HupalupaLokasyonReport() {
  const [html, setHtml] = useState(null);
  const [height, setHeight] = useState(720);
  const boxRef = useRef(null);

  useEffect(() => {
    let alive = true;
    import('./hupalupaLokasyonReportHtml')
      .then((mod) => { if (alive) setHtml(mod.default); })
      .catch(() => {
        if (alive) setHtml('<p style="font:14px sans-serif;padding:24px">Rapor yüklenemedi.</p>');
      });
    return () => { alive = false; };
  }, []);

  // iframe'i içerik alanının kalan yüksekliğine oturt. Rapor kendi içinde kayar,
  // sayfa gövdesi kaymaz — iki kaydırma çubuğu üst üste binmesin.
  useEffect(() => {
    const fit = () => {
      const top = boxRef.current?.getBoundingClientRect().top ?? 0;
      setHeight(Math.max(480, window.innerHeight - top - 16));
    };
    fit();
    window.addEventListener('resize', fit);
    return () => window.removeEventListener('resize', fit);
  }, [html]);

  return (
    <div ref={boxRef} className="px-2 pb-2">
      {html ? (
        <iframe
          title="HUPALUPA · Lokasyon Röntgeni"
          srcDoc={html}
          style={{
            width: '100%',
            height,
            border: '1px solid #e5e7eb',
            borderRadius: 12,
            display: 'block',
            background: '#F1F3F6',
          }}
        />
      ) : (
        <div
          style={{ height, borderRadius: 12, background: '#F1F3F6' }}
          aria-busy="true"
        />
      )}
    </div>
  );
}
